import(/* webpackMode: "eager" */ "/codebuild/output/src426540595/src/rev-pay-landing/src/app/(auth)/forgot-password/page.tsx");
